import axios from './axios';
import Cookies from 'js-cookie';

export default {
  login: async body => {
    const { data } = await axios.post(`/auth/login`, body);
    //set expiration to an hour from now
    Cookies.set('bearerToken', data, { expires: 1 / 3 });
    return data;
  },

  logout: async () => {
    const { data } = await axios.get('/auth/logout');
    Cookies.remove('bearerToken');
    Cookies.remove('ksBearerToken');
    return data;
  },

  getUserProfile: async () => {
    const { data } = await axios.get('/auth/user');
    return data;
  },

  updateUserEnrollment: async (id, projectGroupId, step) => {
    const { data } = await axios.post(
      `/profiles/${id}/enrollment/${projectGroupId}?step=${step}`
    );
    return data;
  },

  deleteEnrollment: async (id, projectGroupId) => {
    const { data } = await axios.delete(
      `/profiles/${id}/enrollment/${projectGroupId}`
    );
    return data;
  },

  impersonate: async body => {
    const res = await axios.post(`/auth/impersonator-login`, body);
    //set expiration to an hour from now
    Cookies.set('ksBearerToken', res.data, { expires: 1 / 3 });
    return res;
  },

  refresh: async (token, type) => {
    const config = {
      headers: {
        Authorization: token
      }
    };
    const res = await axios.get(`/auth/refresh-token`, config);
    Cookies.set(type, res.data);
    return res.data;
  }
};
